class ProductSingle extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.slider = this.querySelector('.js-product-slider');
      setTimeout(() => {
        this.hideSlidesLargerThanFive(); // Hide slides with alt number > 5 on load
      }, 5000);
    }
  
    hideSlidesLargerThanFive() {
      const currentslides = this.querySelectorAll('.thumbnail-list__item--active');
      const slides = this.querySelectorAll('.thumbnail-list__item');
      const activeSlide = currentslides[0];
      const activeAlt = activeSlide ? activeSlide.querySelector('img.media-gallery__thumb-image').getAttribute('alt') : null;
  
      if (!activeAlt) {
        console.log('No active thumbnail found. Retrying in 5 seconds...');
        setTimeout(() => {
          this.hideSlidesLargerThanFive(); // Retry after 5 seconds
        }, 5000);
        return; // Exit the function if no active thumbnail is found
      }
  
      const baseAltTag = activeAlt.replace(/(\d+)$/, ''); 
      const allowedactiveAltTags = [];
      console.log('activeAlt::', baseAltTag);
      for (let i = 1; i <= 5; i++) {
        allowedactiveAltTags.push(`${baseAltTag}${i}`);
      }
      console.log('allowedactiveAltTags::', allowedactiveAltTags);
  
      const slides1 = this.querySelectorAll('.thumbnail-list__item');
      slides1.forEach((slide) => {
        const img = slide.querySelector('img.media-gallery__thumb-image');
        if (img) {
          const imgAlt = img.getAttribute('alt'); // Get the alt attribute of the image
          if (allowedactiveAltTags.includes(imgAlt)) {
            slide.style.display = 'block'; // Show the slide
          } else {
            // slide.style.display = 'none'; // Hide the slide
          }
        }
      });
    }
  
    updateMedia() {
      if (!this.slider || !this._variant.featured_media) return;
      const mediaId = this._variant.featured_media.id;
      const mediaAlt = this._variant.featured_media.alt;
      const slide = this.querySelector(
        `.media-gallery__item[data-media-id="${mediaId}"]`,
      );
  
      if (!slide) return;
      const baseAltTag = mediaAlt.replace(/(\d+)$/, ''); // Remove the last digit if it is a number
      const allowedAltTags = [];
      for (let i = 1; i <= 5; i++) {
        allowedAltTags.push(`${baseAltTag}${i}`); // Append numbers 1 to 5
      }
      console.log('allowedAltTags::', allowedAltTags);
      const slides = this.querySelectorAll('.thumbnail-list__item');
      slides.forEach((slide) => {
        const img = slide.querySelector('img.media-gallery__thumb-image');
        if (img) {
          const imgAlt = img.getAttribute('alt'); // Get the alt attribute of the image
          if (allowedAltTags.includes(imgAlt)) {
            slide.style.display = 'block'; // Show the slide
          } else {
            // slide.style.display = 'none'; // Hide the slide
          }
        }
      });
  
      const slideId = slide.getAttribute('data-slide-id');
      if (typeof $ === 'function') {
        const slider = $(this.slider);
        slider.slick('slickGoTo', slideId);
      } else {
        this.slider.setAttribute('data-slide-id', slideId);
      }
    }
  
    set variant(variant) {
      this._variant = variant;
      this.updateMedia();
    }
  
    get variant() {
      return this._variant;
    }
  }
  
  customElements.define('product-single', ProductSingle);